<template>
  <v-sheet>
    <v-row v-if="!headersList.length">
      <v-col class="text-center">
        <v-icon class="mb-1" small>mdi-cancel</v-icon> No Additional Headers
      </v-col>
    </v-row>
    <scroll-wrap v-if="headersList.length" outlined ref="scroller" class="h15">
      <template>
        <v-row v-for="(v, i) in headersList" :key="i">
          <v-col>
            <v-autocomplete
              v-model="v.name"
              label="Header Name"
              :items="headerList"
              outlined
              required
              dense
              hide-details
              @input="methodChanged"
              :rules="rules.text"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
              v-model="v.val"
              label="Header Value"
              outlined
              required
              hide-details
              clearable
              dense
              @input="methodChanged"
              :rules="rules.text"
            >
            </v-text-field>
          </v-col>
          <v-col cols="auto">
            <Tooltip content="Delete Custome Header" color="error" top>
              <v-btn x-small fab text color="error" @click="removeFromList(i)">
                <v-icon>mdi-delete-empty</v-icon>
              </v-btn>
            </Tooltip>
          </v-col>
        </v-row>
      </template>
    </scroll-wrap>
    <v-divider> </v-divider>
    <v-row class="mt-0">
      <v-spacer> </v-spacer>
      <v-col cols="auto">
        <Tooltip
          content="Add Custome Header"
          color="success"
          left
          transition="slide-x-transition"
        >
          <v-hover v-slot="{ hover }">
            <v-btn small :outlined="!hover" color="success" @click="addToList">
              <v-icon>mdi-plus</v-icon> Add
            </v-btn>
          </v-hover>
        </Tooltip>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import { KeyValObj, ListObj } from "@/types";
import { cloneObj, headers, validations } from "@/utils";
import Vue from "vue";
import VueTypes from "vue-types";
import ScrollWrap from "./ScrollWrap.vue";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  name: "RequestHeaders",

  data() {
    return {
      // headersList: [] as ListObj[],
      rules: {
        text: [validations.empty],
      },
    };
  },
  components: {
    ScrollWrap,
    Tooltip,
  },
  props: {
    value: VueTypes.any.def({}),
  },
  methods: {
    parseObj(headersObj: KeyValObj) {
      const headers: ListObj[] = [];
      for (const name in headersObj) {
        headers.push({ name, val: headersObj[name], type: "text" });
      }
      return headers;
    },
    parseArr(list: ListObj[]) {
      const headers: KeyValObj = {};
      list.map((h: ListObj) => {
        headers[h.name] = h.val;
      });
      return cloneObj(headers);
    },
    methodChanged() {
      const headers = this.parseArr(this.headersList);
      console.log(headers);
      this.$emit("input", headers);
    },
    removeFromList(index: number) {
      const list = [...this.headersList];
      list.splice(index, 1);
      this.headersList = list;
      // this.methodChanged();
    },
    addToList() {
      const list = [...this.headersList];
      list.push({
        name: "",
        val: "",
        type: "text",
      });
      this.headersList = list;
      // this.methodChanged();
      // activate scrolling
      const scroller = this.$refs.scroller as Element;
      if (scroller) {
        scroller.scroll();
      }
    },
  },
  computed: {
    headerList(): string[] {
      return headers;
    },
    headersList: {
      get(): ListObj[] {
        const headers = this.parseObj(this.value);
        console.log(headers);
        return headers;
      },
      set(newValue: ListObj[]): void {
        // const headers: any = {};
        // newValue.map((h: ListObj) => {
        //   headers[h.name] = h.val;
        // });
        // this.$emit("changed", { headers });
        console.log(newValue);
        const headers = this.parseArr(newValue);
        console.log(headers);
        this.$emit("input", headers);
      },
    },
  },
  created() {
    // this.headersList = this.parseObj(this.costumeHeaders);
  },
});
</script>
